module.exports = __webpack_public_path__ + "static/media/camera.82e1adbb.svg";